import { redirect } from 'vike/abort';

export function guard(pageContext: Vike.PageContext) {
  if (
    pageContext.routeParams?.chatId !== 'me' &&
    !/^[1-9]+[0-9]*$/.test(pageContext.routeParams?.chatId)
  ) {
    throw redirect('/support-chat');
  }
}
